<template>
  <div class="box-detail" id="contract">
    <div class="left-box" style="flex: 1; min-width: 400px">
      <!-- <div class="head-box">
        <div class="box-left-header" style="width: 100%">
          <div @click="$router.go(-1)" class="goBack c-position-static c-m-0">
            <i class="el-icon-arrow-left"></i>
            <span>合同</span>
            <i class="el-icon-document"></i>
          </div>
        </div>
      </div> -->
      <div class="left-content">
        <el-aside class="message-list-wrapper">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <b>合同信息</b>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="edit"
                v-if="osg.has('Contract,edit')"
              >
                编辑
              </el-button>
            </div>

            <div>
              <span>合同编号</span>
              <span>{{ '：' + (contract.contractdocNum || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>合同详细地址</span>
              <span>{{ '：' + (contract.address || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>维修区域面积</span>
              <span>{{ '：' + (contract.maintainAreaNum || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>维修方具体描述</span>
              <span>{{ '：' + (contract.repairDescribe || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>合同金额</span>
              <span>{{ '：' + (contract.afterRefundMoney || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>优惠金额</span>
              <span>{{ '：' + (contract.discountMoney || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>委托方</span>
              <span>{{ '：' + (contract.contactsName || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>客户电话</span>
              <span>{{ '：' + (contract.contactsPhone || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>客户地址</span>
              <span>{{ '：' + (contract.contactsAddress || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>客户方 经办人</span>
              <span>{{ '：' + (contract.agent || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>乙方</span>
              <span>{{ '：' + (contract.partyB || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>乙方电话</span>
              <span>{{ '：' + (contract.partyBPhone || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>乙方地址</span>
              <span>{{ '：' + (contract.partyBAddress || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>证件号</span>
              <span>{{ '：' + (contract.certificateNum || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>工程质保期</span>
              <span>{{ '：' + (contract.warrantyPeriod || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>乙方经办人</span>
              <span>{{ '：' + (contract.partyBOperator || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>签约时间</span>
              <span>{{ '：' + (contract.signedDate || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>开工日期</span>
              <span>{{ '：' + (contract.startDate || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>竣工日期</span>
              <span>{{ '：' + (contract.endDate || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>施工队长</span>
              <span>{{ '：' + (contract.teamLeader || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>工期</span>
              <span>{{ '：' + (contract.constructionPeriod || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>汇款开户银行</span>
              <span>{{ '：' + (contract.remittanceBank || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>汇款户名</span>
              <span>{{ '：' + (contract.remittanceName || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>汇款账户</span>
              <span>{{ '：' + (contract.remittanceAccount || '') }}</span>
              <el-divider></el-divider>
            </div>
            <div>
              <span>委托签订日期</span>
              <span>{{ '：' + (contract.time || '') }}</span>
              <el-divider></el-divider>
            </div>

            <div v-for="(extField, index) in extFields" :key="index">
              <template v-if="extField.preset == '1'">
                <span>{{ extField.nameDisp }}</span>
                <span>
                  {{
                    '：' +
                      (formatterCodelabel(
                        contract[extField.name],
                        extField.valueOption,
                        extField.type
                      ) || '')
                  }}
                </span>
              </template>
              <template v-else>
                <span>{{ extField.nameDisp }}</span>
                <span v-if="extField.type == 'switch'">
                  {{
                    '：' +
                      (formatterSwitch(
                        contract.exts[extField.name],
                        extField.frontEndConfig ? extField.frontEndConfig : {}
                      ) || '')
                  }}
                </span>
                <span v-else>
                  {{
                    '：' +
                      (formatterCodelabel(
                        contract.exts[extField.name],
                        extField.valueOption,
                        extField.type
                      ) || '')
                  }}
                </span>
              </template>

              <el-divider></el-divider>
            </div>
          </el-card>
        </el-aside>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="财务流水" name="payList">
          <div class="box-center-tool"></div>
          <div class="box-center-content">
            <div class="content-box" style="height: 100%">
              <div class="content-table">
                <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data">
                  <el-table-column
                    prop="executor"
                    label="付款人"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="payType"
                    label="付款方式"
                    width="150px"
                    show-overflow-tooltip
                    :formatter="formatterPayType"
                  ></el-table-column>
                  <!-- <el-table-column
                    prop="userId"
                    label="委托人"
                    width="130px"
                    :formatter="formatUserId"
                  ></el-table-column> -->
                  <!-- <el-table-column prop="phone" label="委托人电话" width="110px"></el-table-column> -->
                  <!-- <el-table-column prop="_id" label="流水号" width="160px"></el-table-column> -->
                  <!-- <el-table-column
                    prop="serviceAppointmentId"
                    label="工单流水号"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column> -->
                  <!-- <el-table-column
                    prop="auditstate"
                    label="审核状态"
                    width="130px"
                    show-overflow-tooltip
                    :formatter="formatterAuditstate"
                  ></el-table-column> -->
                  <el-table-column
                    prop="createTime"
                    label="创建时间"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="tradeIn"
                    label="款项来源"
                    width="150px"
                    show-overflow-tooltip
                    :formatter="formatterTradeIn"
                  ></el-table-column>
                  <el-table-column
                    prop="type"
                    label="类型"
                    width="150px"
                    show-overflow-tooltip
                    :formatter="formatterPaymentRecordType"
                  ></el-table-column>
                  <!-- <el-table-column
                    prop="payState"
                    label="收款状态"
                    width="150px"
                    show-overflow-tooltip
                    :formatter="formatterPayState"
                  ></el-table-column> -->
                  <el-table-column
                    prop="paidAmount"
                    label="已收款金额"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="difference"
                    label="未付金额"
                    width="150px"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span :style="`${scope.row.difference < 0 ? 'color:red' : 'color:#000'}`">
                        {{ scope.row.difference }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    label="本次审核金额(元)"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <!-- <el-table-column
                    prop="totalAmount"
                    label="总金额(元)"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column> -->
                  <!-- <el-table-column
                    prop="createUserName"
                    label="流水操作人"
                    width="150px"
                    show-overflow-tooltip
                  ></el-table-column> -->
                  <el-table-column
                    prop="orderType"
                    label="款项类型"
                    width="150px"
                    show-overflow-tooltip
                    :formatter="formatterOrderType"
                  ></el-table-column>
                  <el-table-column
                    prop="payTime"
                    label="付款时间"
                    min-width="160px"
                    show-overflow-tooltip
                  ></el-table-column>

                  <el-table-column
                    prop="exts.payCarryOverMoney"
                    label="结转金额"
                    min-width="160px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="exts.payCarryOverTime"
                    label="结转时间"
                    min-width="160px"
                    show-overflow-tooltip
                  ></el-table-column>

                  <el-table-column
                    prop="memo"
                    label="备注"
                    min-width="160px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="body"
                    label="审批批语"
                    min-width="160px"
                    show-overflow-tooltip
                  ></el-table-column>
                  <!-- <template v-for="(extFiel, index) in contactsExtFields">
                  <el-table-column
                    min-width="180px"
                    show-overflow-tooltip
                    :label="extFiel.nameDisp"
                    :key="index"
                    v-if="!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide"
                  >
                    <template slot-scope="scope">
                      {{ formatterCodelabel(scope.row.exts[extFiel.name], extFiel.valueOption) }}
                    </template>
                  </el-table-column>
                </template> -->
                </el-table>
                <el-pagination
                  class="pagination"
                  @size-change="pageSizeChange"
                  @current-change="pageChange"
                  :current-page="fpi.page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="fpi.rows"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="fpi.total"
                ></el-pagination>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="客户信息" name="customer">
          <div class="box-center-tool"></div>
          <div
            class="box-center-content c_no_pointer"
            style="background: #fff; padding: 30px 50px; display: flex"
          >
            <el-form
              ref="formData"
              :model="formData"
              :rules="rules"
              label-width="120px"
              label-position="left"
              hide-required-asterisk
            >
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="formData.name"
                  suffix-icon="el-icon-user"
                  width="100px"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="formData.phone" suffix-icon="el-icon-mobile-phone"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="formData.email" suffix-icon="el-icon-message"></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="address">
                <el-input v-model="formData.address" suffix-icon="el-icon-map-location"></el-input>
              </el-form-item>
              <el-form-item
                v-for="(contactsExtField, idx) in contactsExtFields"
                :key="idx"
                :label="contactsExtField.nameDisp"
              >
                <template
                  v-if="
                    contactsExtField.type == 'text' ||
                      contactsExtField.type == 'textarea' ||
                      contactsExtField.type == 'number'
                  "
                >
                  <el-input
                    v-model="formData.exts[contactsExtField.name]"
                    :type="contactsExtField.type"
                    disabled
                  ></el-input>
                </template>
                <template v-if="contactsExtField.type == 'radio'">
                  <el-radio-group v-model="formData.exts[contactsExtField.name]">
                    <el-radio
                      disabled
                      v-for="item in options[contactsExtField.valueOption]"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="contactsExtField.type == 'checkbox'" @change="$forceUpdate()">
                  <el-checkbox-group v-model="formData.exts[contactsExtField.name]">
                    <el-checkbox
                      disabled
                      v-for="item in options[contactsExtField.valueOption]"
                      :label="item.value"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="contactsExtField.type == 'select'">
                  <el-select
                    disabled
                    v-model="formData.exts[contactsExtField.name]"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in options[contactsExtField.valueOption]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-if="contactsExtField.type == 'cascade'">
                  <el-cascader
                    disabled
                    clearable
                    v-model="formData.exts[contactsExtField.name]"
                    :options="options[contactsExtField.valueOption]"
                    :props="{ checkStrictly: true, label: 'name' }"
                  ></el-cascader>
                </template>
                <template v-if="contactsExtField.type == 'time'">
                  <el-time-select
                    disabled
                    v-model="formData.exts[contactsExtField.name]"
                    placeholder="选择时间"
                  ></el-time-select>
                </template>
                <template
                  v-if="contactsExtField.type == 'date' || contactsExtField.type == 'datetime'"
                >
                  <el-date-picker
                    disabled
                    v-model="formData.exts[contactsExtField.name]"
                    :type="contactsExtField.type"
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-if="contactsExtField.type == 'switch'">
                  <el-switch
                    disabled
                    v-model="formData.exts[contactsExtField.name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                    active-text="是"
                    inactive-text="否"
                  ></el-switch>
                </template>
                <template v-if="contactsExtField.type == 'rate'">
                  <el-rate
                    disabled
                    v-model="formData.exts[contactsExtField.name]"
                    @change="$forceUpdate()"
                  ></el-rate>
                </template>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="结算明细" name="settleDetail">
          <div class="box-center-tool"></div>
          <div class="box-center-content settleTable">
            <el-table
              id="table-content"
              ref="settleItem"
              highlight-current-row
              show-summary
              :summary-method="getSummaryTotal"
              :data="settleDetailData.itemList"
              :default-sort="{
                prop: 'createTime',
                order: 'ascending'
              }"
              border
              stripe
              height="100%"
            >
              <el-table-column type="index" width="50" fixed></el-table-column>
              <el-table-column label="签订日期" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.data && scope.row.data.signedDate">
                    {{ scope.row.data.signedDate.split(' ')[0] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="data.contractdocNum"
                label="合同编号"
                min-width="140px"
              ></el-table-column>
              <el-table-column
                prop="data.contactsName"
                label="业主姓名"
                width="100"
                fixed
              ></el-table-column>
              <el-table-column
                prop="data.contactsPhone"
                label="联系电话"
                min-width="100px"
              ></el-table-column>
              <el-table-column
                prop="data.partyB"
                label="服务商"
                min-width="150px"
              ></el-table-column>
              <el-table-column
                prop="data.teamLeader"
                label="工队长"
                min-width="100px"
              ></el-table-column>
              <el-table-column
                prop="data.serviceHousekeeper"
                label="管家"
                min-width="100px"
              ></el-table-column>
              <el-table-column
                prop="data.address"
                label="施工地址"
                min-width="150px"
              ></el-table-column>
              <el-table-column label="完工日期" min-width="90px">
                <template slot-scope="scope">
                  <span v-if="scope.row.data && scope.row.data.endDate">
                    {{ scope.row.data.endDate.split(' ')[0] }}
                  </span>
                </template>
              </el-table-column>

              <!-- <el-table-column
                prop="data.endDate"
                label="是否已完工"
                min-width="150px"
              ></el-table-column>
              <el-table-column
                prop="data.endDate"
                label="是否已付清"
                min-width="150px"
              ></el-table-column> -->
              <!-- 结算明细 -->
              <el-table-column
                prop="createTime"
                label="结算发起时间"
                min-width="150px"
              ></el-table-column>
              <el-table-column prop="amountOrigin" label="实付金额(元)" width="100">
                <template slot="header">
                  <span class="c_title_color">实付金额(元)</span>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.amountOrigin | toMoney }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="data.settledCardinal"
                label="已结基数金额(元)"
                min-width="100px"
              ></el-table-column> -->
              <el-table-column prop="settleItemAmount" label="实收平台服务费(元)" width="140">
                <template slot="header">
                  <span class="c_title_color">实收平台服务费(元)</span>
                </template>

                <template slot-scope="scope">
                  {{ scope.row.settleItemAmount | toMoney }}
                </template>
              </el-table-column>
              <el-table-column
                label-class-name="c_red"
                prop="adjustAmount"
                label="调整金额(元)"
                width="150"
              >
                <template slot="header">
                  <span class="c_title_color">调整金额(元)</span>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.edit">
                    <el-input-number
                      v-model="scope.row.adjustAmount"
                      :controls="false"
                      :precision="2"
                      style="width: 100%; box-sizing: border-box"
                    ></el-input-number>
                  </template>
                  <template v-else>
                    <span
                      :class="
                        scope.row.adjustAmount > 0
                          ? 'c_red'
                          : scope.row.adjustAmount < 0
                          ? 'c_red'
                          : ''
                      "
                    >
                      {{ scope.row.adjustAmount | toMoney }}
                    </span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="实结金额(元)" width="110">
                <template slot="header">
                  <span class="c_title_color">实结金额(元)</span>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.amount | toMoney }}
                </template>
              </el-table-column>
              <el-table-column label="调整备注" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                  <template v-if="scope.row.edit">
                    <el-input
                      v-model="scope.row.adjustRemark"
                      style="width: 100%; box-sizing: border-box"
                    ></el-input>
                  </template>
                  <template v-else>
                    <span>{{ scope.row.adjustRemark }}</span>
                  </template>
                </template>
              </el-table-column>
              <!-- <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.edit"
                    type="success"
                    @click="doSaveItem(scope.row)"
                    size="mini"
                  >
                    保存
                  </el-button>
                  <el-button v-else @click="scope.row.edit = true" size="mini">调整</el-button>
                  <template>
                    <el-button @click="doRemove(scope.row._id)" size="mini">删除</el-button>
                  </template>
                </template>
              </el-table-column> -->
              <el-table-column label="结算政策" width="500px">
                <template slot-scope="scope" v-if="scope.row.rules.length > 0">
                  <el-table :data="scope.row.rules">
                    <el-table-column
                      prop="settleRule.name"
                      label="政策名称"
                      width="150px"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="settleRule.currentDeductType"
                      :formatter="formatDeductType"
                      label="扣减科目"
                    ></el-table-column>
                    <!-- <el-table-column prop="cardinal" label="基数金额(元)"></el-table-column> -->
                    <el-table-column prop="amountDeduct" label="实际平台服务费"></el-table-column>
                    <el-table-column label="结算数值">
                      <template slot-scope="scope2">
                        {{ scope2.row.settleRule.currentCalcTypeValu }}
                        {{ scope2.row.settleRule.currentCalcType == 0 ? '%' : '元' }}
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="跟进记录" name="record" v-if="handleType == 'NPS'">
          <div class="box-center-content">
            <div class="activity-card" v-for="(reco, i) in record.fpi.data" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  跟进记录
                </span>
                <span>{{ reco.createTime }}</span>
              </div>
              <div class="activity-card-content">
                <div class="c-flex" v-if="reco.serviceAppointmentOrderNum">
                  <el-link
                    :href="'/ServiceAppointment/' + reco.serviceAppointmentId"
                    target="_blank"
                  >
                    <span>工单编号：</span>
                    <span>{{ reco.serviceAppointmentOrderNum }}</span>
                  </el-link>
                </div>
                <div class="c-flex">
                  <span>通话状态：</span>
                  <span
                    v-text="formatterCodelabel(reco.dedicateMode, 'LEADSTATUS', 'cascade')"
                  ></span>
                </div>
                <div v-if="reco.nextTime">
                  <span>下次联系时间：</span>
                  <span>{{ reco.nextTime }}</span>
                </div>
                <div v-if="reco.name">
                  <span>姓名：</span>
                  <span>{{ reco.name }}</span>
                </div>
                <div v-if="reco.phone">
                  <span>手机号：</span>
                  <span>{{ reco.phone }}</span>
                </div>
                <div v-if="reco.province">
                  <span>省：</span>
                  <span>{{ formatProvince(reco.province) || '' }}</span>
                </div>
                <div v-if="reco.city">
                  <span>市：</span>
                  <span>{{ formatCity(reco.city) || '' }}</span>
                </div>
                <div v-if="reco.district">
                  <span>区：</span>
                  <span>{{ formatDistrict(reco.district) || '' }}</span>
                </div>
                <div v-if="reco.address">
                  <span>地址：</span>
                  <span>{{ reco.address }}</span>
                </div>
                <div v-if="reco.channel">
                  <span>信息渠道：</span>
                  <span
                    v-text="
                      osg.formatCascade(
                        'channel',
                        osg.isJson(reco.channel) ? JSON.parse(reco.channel) : reco.channel
                      )
                    "
                  ></span>
                </div>
                <div v-if="reco.leakagesite">
                  <span>维修部位：</span>
                  <span
                    v-text="
                      osg.formatCascadeMultiple(
                        'repairParts',
                        osg.isJson(reco.leakagesite)
                          ? JSON.parse(reco.leakagesite)
                          : reco.leakagesite
                      )
                    "
                  ></span>
                </div>

                <div v-if="reco.memo">备注： {{ reco.memo }}</div>
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ reco.createUserName }}</span>
                <el-button
                  v-if="reco.callId"
                  icon="el-icon-view"
                  size="mini"
                  @click="viewCallRecord(reco.callId)"
                >
                  查看通话记录
                </el-button>
              </div>
            </div>
          </div>
          <!-- </template> -->
          <el-dialog
            title="通话记录"
            id="callRecordDialog"
            :visible.sync="record.openCallRecord"
            @close="record.callData = {}"
          >
            <div class="box-center-content" style="border: 1px solid #ccc; border-radius: 6px">
              <!-- v-for="(item, i) in record.callData" :key="i" -->
              <div class="activity-card">
                <div class="activity-card-header">
                  <span class="c-font-500">
                    <i class="el-icon-phone-outline c-w-30"></i>
                    <span v-if="record.callData.callDirection == '0'">呼入</span>
                    <span v-else-if="record.callData.callDirection == '1'">呼出</span>
                  </span>
                  <span v-if="record.callData.callWay == 4">
                    {{ formatMiddleCallResult(record.callData.middleCallResult) }}
                  </span>
                  <span v-else>{{ formatCallResult(record.callData.callResult) }}</span>
                </div>
                <div class="activity-card-content">
                  <div>
                    主叫：{{ record.callData.callerName }}
                    {{ record.callData.caller }}
                  </div>
                  <div>
                    被叫：{{
                      record.callData.callWay == 4
                        ? record.callData.calleeName || ''
                        : record.callData.callDirection == '0'
                        ? record.callData.calleeName || ''
                        : record.callData.calleeName || formData.name || ''
                    }}{{ ' ' + record.callData.callee }}
                  </div>
                  <div>
                    通话时间：{{ record.callData.startTimeStr }} 至
                    {{ record.callData.endTimeStr }}
                  </div>
                  <audio
                    v-if="record.callData.recordUrl"
                    class="c-m-t-15 w-1"
                    controls
                    :src="record.callData.recordUrl"
                    :controlsList="osg.has('Contract,downloadAudio') ? null : 'nodownload'"
                    @contextmenu.prevent="osg.has('Contract,downloadAudio') ? true : ''"
                  >
                    您的浏览器不支持 audio 标签。
                  </audio>
                </div>
                <div class="activity-card-footer">
                  <!-- <span>操作人：{{ item.createUserName }}</span> -->
                  <span></span>
                  <span>生成记录时间：{{ record.callData.createTime }}</span>
                </div>
              </div>
            </div>
            <div slot="footer">
              <el-button
                @click="
                  record.openCallRecord = false;
                  record.callData = {};
                "
              >
                关闭
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="NPS表单" name="TabNPS" v-if="handleType == 'NPS' && serviceState">
          <ul class="c-flex c-flex-between" style="padding: 6px 10px;padding-top: 0;">
            <li>
              <el-popconfirm
                confirmButtonText="呼出"
                cancelButtonText="取消"
                icon="el-icon-phone"
                iconColor="#409EFF"
                hideIcon
                :title="formData.name + ' ' + formData.phone"
                @confirm="
                  osg.sobot.selfCallOut(
                    {
                      callNum: contract.contactsPhone,
                      bizType: 'Contract',
                      bizId: contract._id
                    },
                    callOutBack
                  )
                "
                popper-class="c-popconfirm"
              >
                <!-- @cancel="
                  osg.sobot.selfCallOut(
                    {
                      callNum: contract.contactsPhone,
                      bizType: 'Contract',
                      bizId: contract._id
                    },
                    callOutBack
                  )
                " -->
                <el-button type="primary" icon="el-icon-phone" circle slot="reference"></el-button>
              </el-popconfirm>
            </li>
            <li>
              <el-button type="primary" @click="doNewNPS">
                创建NPS
              </el-button>
            </li>
          </ul>
          <div class="box-center-content" v-if="TabNPS.data._id">
            <div class="activity-card">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  NPS表单
                </span>
                <span>{{ TabNPS.data.createTime }}</span>
              </div>
              <div class="activity-card-content c-pointer-n">
                <c-form
                  :formData="TabNPS.data"
                  :fields="extFieldsDisableNPS"
                  :options="options"
                  ref="NPSform"
                  :upload="upload"
                  labelWidth="100px"
                  :area="area"
                  @changeForm="osg.changeForm"
                >
                  <template slot="questionAndReply">
                    <el-card class="box-card" shadow="never">
                      <!-- <div slot="header" class="c-flex c_item_center c_flex_between">
                  <span>问题库</span>
                  <el-button
                    style="float: right; padding: 3px 0"
                    type="text"
                    @click="TabNPS.data.questionAndReply.push({ question: '', whether: '' })"
                    >新增</el-button
                  >
                </div> -->
                      <div v-for="(item, index) in TabNPS.data.questionAndReply" :key="index">
                        <div
                          :class="
                            `${
                              TabNPS.data.questionAndReply.length - 1 == index ? '' : 'c-m-b-20 '
                            }c-flex c-flex-item c-flex-between`
                          "
                        >
                          <el-select
                            v-model="item.question"
                            placeholder="请选择问题"
                            style="flex: 2"
                            :disabled="true"
                          >
                            <el-option
                              v-for="item in options['questionBank']"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              :disabled="
                                TabNPS.data.questionAndReply.some(l => l.question == item.value)
                              "
                            ></el-option>
                          </el-select>
                          <div style="flex: 1" class="c-flex c-flex-around">
                            <el-radio-group
                              v-model="item.whether"
                              class="c-m-l-10 c-w-1 c-flex c_flex_center"
                              :disabled="true"
                            >
                              <el-radio
                                v-for="item in options['NPSreply']"
                                :key="item.value"
                                :label="item.value"
                              >
                                {{ item.label }}
                              </el-radio>
                            </el-radio-group>
                            <!-- <el-link :underline="false" @click="TabNPS.data.questionAndReply.splice(index, 1)">
                            <i class="c-m-l-15 el-icon-delete"></i>
                            </el-link> -->
                          </div>
                        </div>
                      </div>
                    </el-card>
                  </template>
                </c-form>
              </div>
              <div class="activity-card-footer">
                <span>创建人：{{ TabNPS.data.createUserName }}</span>
              </div>
            </div>
          </div>

          <el-dialog
            title="NPS信息"
            :visible.sync="TabNPS.openRecord"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <el-form
              :model="record.recordFormData"
              :rules="rules"
              ref="recordFormData"
              label-width="3px"
              label-position="top"
              hide-required-asterisk:true
              :inline="true"
            >
              <el-divider content-position="center">
                <i class="el-icon-info"></i>
                以下为跟进记录信息
              </el-divider>

              <el-form-item
                style="width: 46%"
                label="通话状态"
                prop="dedicateMode"
                :rules="{
                  required: true,
                  type: 'array',
                  trigger: 'blur',
                  message: '通话状态不能为空'
                }"
              >
                <el-cascader
                  popper-class="cascaderLabelHide-wrapper"
                  ref="cascaderRRdedicateMode"
                  clearable
                  v-model="record.recordFormData.dedicateMode"
                  :options="options['LEADSTATUS']"
                  :props="{
                    checkStrictly: false,
                    label: 'name',
                    expandTrigger: 'hover'
                  }"
                >
                  <template slot-scope="{ node, data }" v-show="data.value == 0">
                    <span>{{ data.name }}</span>
                  </template>
                </el-cascader>
              </el-form-item>
              <el-form-item style="width: 46%" label="下次联系时间" prop="nextTime">
                <el-date-picker
                  v-model="record.recordFormData.nextTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="下次联系时间"
                ></el-date-picker>
              </el-form-item>
            </el-form>
            <el-input
              type="textarea"
              v-model="record.recordFormData.memo"
              maxlength="200"
              show-word-limit
              placeholder="备注"
            ></el-input>

            <c-form
              :formData="TabNPS.data"
              :fields="extFieldsNPS"
              :options="options"
              ref="form"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              style="margin-top:20px"
              @changeForm="osg.changeForm"
            >
              <template slot="questionAndReply">
                <el-card class="box-card" shadow="hover">
                  <div
                    slot="header"
                    class="c-flex c_item_center"
                    style="justify-content: space-between"
                  >
                    <span>问题库</span>
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      @click="
                        TabNPS.data.questionAndReply.push({ question: '', reply: '', whether: '' })
                      "
                      v-if="!TabNPS.data._id"
                    >
                      新增
                    </el-button>
                  </div>
                  <div
                    v-for="(item, index) in TabNPS.data.questionAndReply"
                    :key="index"
                    :class="
                      `${TabNPS.data.questionAndReply.length - 1 == index ? '' : 'c-m-b-20 '}`
                    "
                  >
                    <div :class="`c-flex c-flex-item c-flex-between`">
                      <el-select
                        :disabled="TabNPS.data._id ? true : false"
                        v-model="item.question"
                        placeholder="请选择问题"
                        style="flex: 2"
                        @change="selectionQuestion($event, item)"
                      >
                        <el-option
                          v-for="item in options['questionBank']"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          :disabled="
                            TabNPS.data.questionAndReply.some(l => l.question == item.value)
                          "
                        ></el-option>
                      </el-select>
                      <div style="flex: 1;align-items: center;" class="c-flex c-flex-around">
                        <el-radio-group
                          v-model="item.whether"
                          :disabled="TabNPS.data._id ? true : false"
                          class="c-m-l-10 c-flex"
                        >
                          <el-radio
                            v-for="item in options['NPSreply']"
                            :key="item.value"
                            :label="item.value"
                          >
                            {{ item.label }}
                          </el-radio>
                        </el-radio-group>

                        <el-link
                          v-if="!TabNPS.data._id"
                          :underline="false"
                          @click="TabNPS.data.questionAndReply.splice(index, 1)"
                        >
                          <i class="c-m-l-15 el-icon-delete"></i>
                        </el-link>
                      </div>
                    </div>
                    <div class="c_red" v-if="item.whether > 0 && item.question">
                      此选项则会生成{{ String(item.reply) }}元罚款！
                    </div>
                  </div>
                </el-card>
              </template>
            </c-form>
            <div slot="footer">
              <div class="c-flex c_flex_between">
                <div><el-button type="primary" @click="saveRecord">创建跟进记录</el-button></div>
                <div>
                  <el-button type="primary" @click="saveNPS">确 定</el-button>
                  <el-button
                    @click="
                      TabNPS.openRecord = false;
                      getTabNPS();
                    "
                  >
                    取 消
                  </el-button>
                </div>
              </div>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="扣款" name="ticket">
          <div class="box-center-content" v-if="ticket.fpi.data.questionAndReply.length">
            <div class="activity-card">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  扣款
                </span>
                <span>{{ ticket.fpi.data.createTime }}</span>
              </div>
              <div class="activity-card-content">
                <el-card class="box-card" shadow="never">
                  <div
                    v-for="(item, index) in ticket.fpi.data.questionAndReply.filter(
                      q => q.whether > 0
                    )"
                    :key="index"
                  >
                    <template>
                      <div>
                        <span class="c-m-r-10">{{ index + 1 }}.</span>
                        <span>
                          <span class="c-m-r-10" style="display: inline-block;">
                            {{ String(item.question) }}
                          </span>
                          <span v-text="`扣款￥${String(item.reply)}元`"></span>
                        </span>
                      </div>
                      <el-divider></el-divider>
                    </template>

                    <!-- <div
                      :class="`${
                        ticket.fpi.data.questionAndReply.length - 1 == index ? '' : 'c-m-b-20 '
                      }c-flex c-flex-item c-flex-between`"
                    >
                      <el-table :data="[ticket.fpi.data]" highlight-current-row style="width: 100%">
                        <el-table-column type="index" width="50"> </el-table-column>
                        <el-table-column label="">
                          <template slot-scope="scope"> </template>
                        </el-table-column>
                      </el-table>
                    </div> -->
                  </div>
                  <div v-if="ticket.fpi.data.urlPath">
                    PDF下载地址：
                    <el-link
                      :href="
                        'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                          encodeURIComponent(ticket.fpi.data.urlPath)
                      "
                      target="_blank"
                    >
                      {{ ticket.fpi.data.urlPath }}
                    </el-link>
                  </div>
                </el-card>
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ ticket.fpi.data.createUserName }}</span>
                <el-button
                  icon="el-icon-view"
                  size="mini"
                  @click="viewForfeit"
                  v-if="ticket.isforfeitLog"
                >
                  查看罚款日志
                </el-button>
              </div>
            </div>
          </div>
          <el-dialog
            v-if="ticket.openForfeitogDetail"
            title="罚款日志记录"
            :visible.sync="ticket.openForfeitogDetail"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <div>
              <div class="activity-card" v-for="(log, i) in ticket.log.fpi.data" :key="i">
                <div class="activity-card-header">
                  <span class="c-font-500">
                    <i class="el-icon-monitor c-w-30"></i>
                    {{ log.title }}
                  </span>
                  <span>{{ log.createTime }}</span>
                </div>
                <div class="activity-card-content">
                  {{ log.content }}
                </div>
                <div class="activity-card-footer">
                  <span>操作人：{{ log.createUserName }}</span>
                </div>
              </div>
            </div>
            <div slot="footer">
              <el-button @click="ticket.openForfeitogDetail = false">关 闭</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="合同业务跟踪" name="contractLog" v-if="osg.has('Contract,exception')">
          <bizStackTrace :params="{ sid: id }" v-if="id"></bizStackTrace>
        </el-tab-pane>
        <el-tab-pane label="NPS业务跟踪" name="NPSlog" v-if="osg.has('Contract,exception')">
          <bizStackTrace :params="{ sid: TabNPS.data._id }" v-if="TabNPS.data._id"></bizStackTrace>
        </el-tab-pane>
        <el-tab-pane label="操作记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse v-model="activeNames">
          <el-collapse-item v-if="handleType == 'NPS'" name="NPS">
            <template slot="title">
              <span>重复合同</span>
            </template>
            <div class="card-group">
              <!-- <template > -->
              <div class="card-item" v-for="(item, i) of repeatContract" :key="i">
                <div>
                  <i class="el-icon-s-custom card-item-logo" style="color: #606266"></i>
                </div>
                <div>
                  <p class="contractLink">
                    合同编号：
                    <el-link
                      :href="`/Contract/${item._id}?handleType=${handleType}`"
                      target="_blank"
                    >
                      {{ item.contractdocNum }}
                    </el-link>
                  </p>
                  <p>创建时间：{{ item.createTime }}</p>
                </div>
                <!-- <div class="c-w-1">
                  <p class="contractLink">
                    <el-link
                      :href="`/Contract/${item._id}?handleType=${handleType}`"
                      target="_blank"
                    >
                      合同编号： {{ item.contractdocNum }}
                    </el-link>
                  </p>
                  <div>
                    <p>创建时间：{{ item.createTime }}</p>
                  </div>
                </div> -->
              </div>
              <!-- <template> -->
            </div>
          </el-collapse-item>
          <el-collapse-item name="1">
            <template slot="title">
              <span>合同下载地址</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of pdfList" :key="i">
                <div>
                  <i class="el-icon-paperclip card-item-logo"></i>
                </div>
                <div>
                  PDF地址：
                  <p class="contractLink">
                    <el-link
                      :href="
                        'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' + encodeURIComponent(item)
                      "
                      target="_blank"
                    >
                      {{ item }}
                    </el-link>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span>附件列表</span>
              <i
                v-if="osg.has('Contract,attachmentUpload') || osg.has('Contract,attachmentRemove')"
                class="el-icon-edit"
                style="padding: 20px"
                @click.prevent.stop="openUploadAttachment('attachmentList', 'attachmentList')"
              ></i>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of attachmentData.attachmentList" :key="i">
                <div>
                  <i class="el-icon-paperclip card-item-logo"></i>
                </div>
                <div>
                  下载地址：
                  <p class="contractLink">
                    <el-link :href="item.url" target="_blank">{{ item.url }}</el-link>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <span>增项列表</span>
            </template>
            <div class="card-group">
              <div v-for="(item, i) of attachmentData.addAttachmentList" :key="i">
                <div class="card-item">
                  <div>
                    <i class="el-icon-paperclip card-item-logo"></i>
                  </div>
                  <div>
                    <div>
                      <div class="c-flex c-flex-between">
                        <span></span>
                        <template v-if="item.qysTradeIn != 0">
                          <i
                            v-if="
                              osg.has('Contract,attachmentUpload') ||
                                osg.has('Contract,attachmentRemove')
                            "
                            class="el-icon-upload2 m-b-10"
                            style="border: 1px solid #f2f2f2;padding: 4px;border-radius: 50%;cursor: pointer;"
                            @click.prevent="
                              openUploadAttachment(
                                'images',
                                'addAttachmentList',
                                i,
                                item.imagesName
                              )
                            "
                          ></i>
                        </template>
                      </div>
                      <p>签约方式：{{ item.qysTradeIn == 0 ? '线上' : '线下' }}</p>
                      <p v-if="item.supplementTreatyStatus">
                        签署状态：{{
                          formatterCodelabel(item.supplementTreatyStatus, 'supplementTreatyStatus')
                        }}
                      </p>
                      <p class="contractLink" v-if="item.contractSupplementTreatypdf">
                        <el-link
                          :href="
                            'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                              encodeURIComponent(item.contractSupplementTreatypdf)
                          "
                          target="_blank"
                        >
                          下载地址：{{ item.contractSupplementTreatypdf }}
                        </el-link>
                      </p>
                    </div>
                    <template v-if="item.imagesName && item.images">
                      <p>上传资料名称：{{ item.imagesName }}</p>
                      <template v-if="item.images">
                        <p
                          class="contractLink"
                          v-for="(imageItem, imageIndex) of item.images"
                          :key="imageIndex"
                        >
                          <el-link :href="imageItem.url" target="_blank">
                            上传资料地址： {{ imageItem.url }}
                          </el-link>
                        </p>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template slot="title">
              <span>减项列表</span>
            </template>
            <div class="card-group">
              <div v-for="(item, i) of attachmentData.deductionAttachmentList" :key="i">
                <div class="card-item">
                  <div>
                    <i class="el-icon-paperclip card-item-logo"></i>
                  </div>
                  <div>
                    <div>
                      <div class="c-flex c-flex-between">
                        <span></span>
                        <template v-if="item.qysTradeIn != 0">
                          <i
                            v-if="
                              osg.has('Contract,attachmentUpload') ||
                                osg.has('Contract,attachmentRemove')
                            "
                            class="el-icon-upload2 m-b-10"
                            style="border: 1px solid #f2f2f2;padding: 4px;border-radius: 50%;cursor: pointer;"
                            @click.prevent="
                              openUploadAttachment(
                                'images',
                                'deductionAttachmentList',
                                i,
                                item.imagesName
                              )
                            "
                          ></i>
                        </template>
                      </div>
                      <p>签约方式：{{ item.qysTradeIn == 0 ? '线上' : '线下' }}</p>
                      <p v-if="item.supplementTreatyStatus">
                        签署状态：{{
                          formatterCodelabel(item.supplementTreatyStatus, 'supplementTreatyStatus')
                        }}
                      </p>
                      <p class="contractLink" v-if="item.contractSupplementTreatypdf">
                        <el-link
                          :href="
                            'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                              encodeURIComponent(item.contractSupplementTreatypdf)
                          "
                          target="_blank"
                        >
                          下载地址：{{ item.contractSupplementTreatypdf }}
                        </el-link>
                      </p>
                    </div>
                    <template v-if="item.imagesName && item.images">
                      <p>上传资料名称：{{ item.imagesName }}</p>
                      <template v-if="item.images">
                        <p
                          class="contractLink"
                          v-for="(imageItem, imageIndex) of item.images"
                          :key="imageIndex"
                        >
                          <el-link :href="imageItem.url" target="_blank">
                            上传资料地址： {{ imageItem.url }}
                          </el-link>
                        </p>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="5">
            <template slot="title">
              <span>补充协议列表</span>
            </template>
            <div class="card-group">
              <div v-for="(item, i) of attachmentData.singleSupplementTreatyList" :key="i">
                <div class="card-item">
                  <div>
                    <i class="el-icon-paperclip card-item-logo"></i>
                  </div>
                  <div>
                    <div>
                      <div class="c-flex c-flex-between">
                        <span></span>
                        <template v-if="item.qysTradeIn != 0">
                          <i
                            v-if="
                              osg.has('Contract,attachmentUpload') ||
                                osg.has('Contract,attachmentRemove')
                            "
                            class="el-icon-upload2 m-b-10"
                            style="border: 1px solid #f2f2f2;padding: 4px;border-radius: 50%;cursor: pointer;"
                            @click.prevent="
                              openUploadAttachment(
                                'images',
                                'singleSupplementTreatyList',
                                i,
                                item.imagesName
                              )
                            "
                          ></i>
                        </template>
                      </div>
                      <p>签约方式：{{ item.qysTradeIn == 0 ? '线上' : '线下' }}</p>
                      <p v-if="item.singleSupplementTreatyStatus">
                        签署状态：{{
                          formatterCodelabel(
                            item.singleSupplementTreatyStatus,
                            'supplementTreatyStatus'
                          )
                        }}
                      </p>
                      <p class="contractLink" v-if="item.singleSupplementTreatypdf">
                        <el-link
                          :href="
                            'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                              encodeURIComponent(item.singleSupplementTreatypdf)
                          "
                          target="_blank"
                        >
                          下载地址：{{ item.singleSupplementTreatypdf }}
                        </el-link>
                      </p>
                    </div>
                    <template v-if="item.imagesName && item.images">
                      <p>上传资料名称：{{ item.imagesName }}</p>
                      <template v-if="item.images">
                        <p
                          class="contractLink"
                          v-for="(imageItem, imageIndex) of item.images"
                          :key="imageIndex"
                        >
                          <el-link :href="imageItem.url" target="_blank">
                            上传资料地址： {{ imageItem.url }}
                          </el-link>
                        </p>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="6">
            <template slot="title">
              <span>退款资料</span>
            </template>
            <div class="card-group">
              <div
                class="card-item c-flex-between"
                v-for="(item, i) of attachmentData.refundDataList"
                :key="i"
              >
                <div>
                  <i class="el-icon-paperclip card-item-logo"></i>
                </div>
                <div style="width: 100%;">
                  <div class="c-flex-between c-flex c-w-100">
                    <p>
                      {{
                        item.refundType == '1'
                          ? '客户版'
                          : item.refundType == '2'
                          ? '服务商垫资版'
                          : '退款说明'
                      }}
                    </p>
                    <template v-if="item.qysTradeIn != 0">
                      <i
                        v-if="
                          osg.has('Contract,attachmentUpload') ||
                            osg.has('Contract,attachmentRemove')
                        "
                        class="el-icon-upload2 m-b-10"
                        style="border: 1px solid #f2f2f2;padding: 4px;border-radius: 50%;cursor: pointer;"
                        @click.prevent="
                          openUploadAttachment('images', 'refundDataList', i, item.imagesName)
                        "
                      ></i>
                    </template>
                  </div>
                  <p>签约方式：{{ item.qysTradeIn == 0 ? '线上' : '线下' }}</p>
                  <p v-if="item.contractRefundStatus">
                    签署状态：{{
                      formatterCodelabel(item.contractRefundStatus, 'supplementTreatyStatus')
                    }}
                  </p>
                  <p class="contractLink" v-if="item.refundUrl">
                    <el-link :href="item.refundUrl" target="_blank">
                      说明下载地址：{{ item.refundUrl }}
                    </el-link>
                  </p>
                  <!-- <p class="contractLink" v-if="item.refundForOrgUrl">
                    <el-link :href="item.refundForOrgUrl" target="_blank">
                      说明下载地址：{{ item.refundForOrgUrl }}
                    </el-link>
                  </p> -->
                  <template v-if="item.imagesName">
                    <p>上传资料名称：{{ item.imagesName }}</p>
                    <template v-if="item.images">
                      <p
                        class="contractLink"
                        v-for="(imageItem, imageIndex) of item.images"
                        :key="imageIndex"
                      >
                        <el-link :href="imageItem.url" target="_blank">
                          上传资料地址： {{ imageItem.url }}
                        </el-link>
                      </p>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="7" v-if="false">
            <template slot="title">
              <span>变更条款</span>
              <!-- <i
                v-if="osg.has('Contract,attachmentUpload') || osg.has('Contract,attachmentRemove')"
                class="el-icon-edit"
                style="padding: 20px"
                @click.prevent="openUploadAttachment('changeClauseList')"
              ></i> -->
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of attachmentData.changeClauseList" :key="i">
                <div>
                  <i class="el-icon-paperclip card-item-logo"></i>
                </div>
                <div>
                  下载地址：
                  <p class="contractLink">
                    <el-link :href="item.url" target="_blank">{{ item.url }}</el-link>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="8">
            <template slot="title">
              <span>工单</span>
              <!-- <el-button type="text"
                         icon="el-icon-plus"
                         @click.stop="newServiceAppointment">
                添加工单
              </el-button> -->
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of serviceAppointment.relatedData" :key="i">
                <div>
                  <i class="el-icon-tickets card-item-logo"></i>
                </div>
                <div>
                  <p>工单编号： {{ item.orderNum }}</p>
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/ServiceAppointment/' + item._id)"
                      target="_blank"
                    >
                      {{ item.title }}
                    </el-link>
                  </p>
                  <p v-if="item.name">姓名： {{ item.name }}</p>
                  <p v-if="item.phone">手机号： {{ item.phone }}</p>
                  <p>阶段：{{ osg.codelabel('stage', item.stage) }}</p>
                  <p>状态：{{ osg.codelabel('STATUS', item.status) }}</p>
                </div>
                <!-- <i
                  class="el-icon-close card-item-icon-remove"
                  @click="removeServiceAppointment(item)"
                ></i> -->
                <!-- <i
                  class="el-icon-edit card-item-icon-edit"
                  @click="editServiceAppointment(item)"
                ></i> -->
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <el-dialog title="合同信息" :visible.sync="messageDialog" width="800px">
      <el-form
        :model="contract"
        label-width="200px"
        label-position="left"
        hide-required-asterisk:true
        ref="formData"
      >
        <!-- <el-form-item label="合同详细地址">
          <el-input v-model="contract.address"></el-input>
        </el-form-item>

        <el-form-item label="维修区域面积">
          <el-input v-model="contract.maintainAreaNum"></el-input>
        </el-form-item>

        <el-form-item label="维修方具体描述">
          <el-input v-model="contract.repairDescribe"></el-input>
        </el-form-item>

        <el-form-item label="合同金额">
          <el-input v-model="contract.payMoney"></el-input>
        </el-form-item>

        <el-form-item label="优惠金额">
          <el-input v-model="contract.discountMoney"></el-input>
        </el-form-item> -->

        <el-form-item
          label="委托方"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '委托方不能为空'
          }"
          prop="contactsName"
        >
          <el-input v-model="contract.contactsName"></el-input>
        </el-form-item>

        <el-form-item
          label="客户电话"
          :rules="{
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: ['blur', 'change']
          }"
          prop="contactsPhone"
        >
          <el-input v-model="contract.contactsPhone"></el-input>
        </el-form-item>

        <!-- <el-form-item label="客户地址">
          <el-input v-model="contract.contactsAddress"></el-input>
        </el-form-item>

        <el-form-item label="客户方 经办人">
          <el-input v-model="contract.agent"></el-input>
        </el-form-item>

        <el-form-item label="乙方">
          <el-input v-model="contract.partyB"></el-input>
        </el-form-item>

        <el-form-item label="乙方电话">
          <el-input v-model="contract.partyBPhone"></el-input>
        </el-form-item>

        <el-form-item label="乙方地址">
          <el-input v-model="contract.partyBAddress"></el-input>
        </el-form-item>

        <el-form-item label="证件号">
          <el-input v-model="contract.certificateNum"></el-input>
        </el-form-item>

        <el-form-item label="工程质保期">
          <el-date-picker
            v-model="contract.warrantyPeriod"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="乙方经办人">
          <el-input v-model="contract.partyBOperator"></el-input>
        </el-form-item>
        <el-form-item label="签约时间">
          <el-date-picker
            v-model="contract.signedDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="开工日期">
          <el-date-picker
            v-model="contract.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="竣工日期">
          <el-date-picker
            v-model="contract.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="施工队长">
          <el-input v-model="contract.teamLeader"></el-input>
        </el-form-item>

        <el-form-item label="工期">
          <el-input v-model="contract.constructionPeriod"></el-input>
        </el-form-item>

        <el-form-item label="汇款开户银行">
          <el-input v-model="contract.remittanceBank"></el-input>
        </el-form-item>

        <el-form-item label="汇款户名">
          <el-input v-model="contract.remittanceName"></el-input>
        </el-form-item>

        <el-form-item label="汇款账户">
          <el-input v-model="contract.remittanceAccount"></el-input>
        </el-form-item>

        <el-form-item label="委托签订日期">
          <el-date-picker
            v-model="contract.time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="contract.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="contract.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="contract.exts[extField.name]">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="contract.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="contract.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="contract.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="contract.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="contract.exts[extField.name]"
              :active-value="extField.frontEndConfig ? extField.frontEndConfig.activeValue : '1'"
              :inactive-value="
                extField.frontEndConfig ? extField.frontEndConfig.inactiveValue : '0'
              "
              :active-text="extField.frontEndConfig ? extField.frontEndConfig.activeText : '是的'"
              :inactive-text="
                extField.frontEndConfig ? extField.frontEndConfig.inactiveText : '否的'
              "
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="contract.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button @click="messageDialog = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="上传信息"
      :visible.sync="attachmentData.openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="attachmentForm" :model="attachmentData" label-width="80px">
        <el-form-item
          label="名称"
          prop="imagesName"
          :rules="{
            required: attachmentData.fileList && attachmentData.fileList.length,
            trigger: 'blur',
            message: '不能为空'
          }"
          v-if="attachmentData.fileListName != 'attachmentList'"
        >
          <el-input v-model="attachmentData.imagesName"></el-input>
        </el-form-item>
        <el-form-item label="上传列表">
          <el-upload
            :action="upload.url"
            :data="upload.data"
            :file-list="attachmentData.fileList"
            multiple
            :class="{
              'c-upload-maxLimit': !osg.has('Contract,attachmentRemove')
            }"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return osg.beforeUpload(file);
              }
            "
            :before-remove="() => osg.has('Contract,attachmentRemove')"
            :on-success="
              (response, file, fileList) => {
                return (attachmentData.fileList = osg.uploadSuccess(
                  response,
                  'attachmentData',
                  fileList,
                  'fileList',
                  true
                ));
              }
            "
            :on-error="osg.uploadError"
            :on-remove="
              (file, fileList) => {
                return (attachmentData.fileList = osg.beforeRemove(
                  file,
                  fileList,
                  'complaintImg',
                  attachmentData.fileList,
                  null,
                  null,
                  true
                ));
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <el-button size="small" type="primary" v-if="osg.has('Contract,attachmentUpload')">
              点击上传
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button type="primary" @click="markEmbodiment">确 定</el-button>
        <el-button @click="attachmentData.openDetail = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'contract',
  props: {
    serviceState: {
      type: String
    }
  },
  components: {
    bizStackTrace: () => import('../../components/bizStackTrace')
  },
  data() {
    return {
      id: null,
      collapse: false,
      formData: { exts: {}, foundTime: '' },
      extFields: [], //合同扩展
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      contactsExtFields: [], //客户扩展
      // contactsExtField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fpi: {},
      options: {
        //合同
        codecfg_productType: { codeId: 'productType' },
        codecfg_unit: { codeId: 'UNIT' },
        codecfg_payState: { codeId: 'payState' },
        codecfg_auditstate: { codeId: 'auditstate' },
        codecfg_payType: { codeId: 'payType' },
        codecfg_PaymentRecordType: { codeId: 'PaymentRecordType' },
        codecfg_orderPayType: { codeId: 'orderPayType' },
        codecfg_tradeIn: { codeId: 'tradeIn' },
        //客户
        // codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        //跟进记录-通话记录
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        codecfg_callMode: { codeId: 'callMode' },
        //员工列表
        roles: [],
        subdistricts: [],
        subdistricts2: [],
        //售后类型细分
        cascadeCode_afterSaleType: { codeId: 'afterSaleType' },
        // 是否
        cascadeCode_IS: { codeId: 'IS' },
        codecfg_NPSreply: { codeId: 'NPSreply' },
        //NPS问题库
        codecfg_questionBank: {
          codeId: 'questionBank'
        },
        //工单
        // codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_callResult: { codeId: 'callResult' },
        codecfg_middleCallResult: { codeId: 'middleCallResult' },
        //结算
        codecfg_unlockPay: { codeId: 'unlockPay' },
        codecfg_deductType: { codeId: 'deductType' },
        //合同增减项协议状态
        codecfg_supplementTreatyStatus: { codeId: 'supplementTreatyStatus' }
      },
      rules: this.$util.rules,
      activeTab: 'payList',
      logData: [],
      searchValue: '',
      openNote: false,
      vqeditor: this.$util.vqeditor,
      pdfList: [], //pdf列表
      attachment: [], //附件列表
      //合同信息
      contract: {
        exts: {}
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      messageDialog: false,
      handleType: '', //操作类型
      // 跟进记录列表
      record: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: [],
        openRecord: false, // 跟进记录弹窗
        recordFormData: {}, //跟进记录表单-上
        SArecordFormData: { gpsPoint: {}, exts: {} }, //跟进记录表单-下（工单信息）
        callData: [], //跟进记录-通话记录
        openCallRecord: false //跟进记录-通话记录弹窗
      },
      //NPS表单
      TabNPS: {
        data: {
          questionAndReply: []
        },
        NPSformData: {},
        openRecord: false // 跟进记录弹窗
      },
      //扣款
      ticket: {
        fpi: {
          //从nps问题提炼出来的问题列表
          data: {
            questionAndReply: []
          }
        },
        forfeit: {
          //真正的罚款列表
          data: []
        },
        log: {
          //罚款列表日志
          data: []
        },
        openForfeitogDetail: false, //罚款日志弹窗
        isforfeitLog: false // 是否能查看罚款日志
      },
      serviceAppointment: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: { exts: {} },
        activeName: 'search',
        searchObj: {} //搜索选中要关联的工单对象
      },
      //合同日志（业务跟踪）
      tenantLog: {
        fpi: {
          data: []
        }
      },
      // 异常日志
      exception: {
        exceptionMsg: '',
        exception: '',
        show: false,
        active: 'exceptionMsg'
      },
      // 操作记录
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      repeatContract: [], //重复合同
      extFieldsNPS: [], //NPS所需表单字段
      extFieldsDisableNPS: [], //NPS表单在页面禁用字段
      activeNames: ['NPS', '1', '2', '3', '4', '5', '6', '7', '8'],
      //上传合同附件
      attachmentData: {
        openDetail: false,
        fileList: [], //表单的上头图片组件列表
        fileListName: '', //附件名字
        name: '', //更改的对象名称
        itemIndex: 0, //细项索引
        imagesName: '', //上传图片的名称
        attachmentList: [], //附件列表
        addAttachmentList: [], //增项列表
        deductionAttachmentList: [], //减项列表
        refundDataList: [], //退款资料列表
        changeClauseList: [], //变更条款列表
        singleSupplementTreatyList: []
      },
      //结算明细
      settleDetailData: {
        itemList: []
      }
    };
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    // this.getFields();
    this.handleType = this.$route.query.handleType; //从地址栏获取操作类型
    this.getFields(() => {
      this.osg.codeoption(() => {
        this.getData(contract => {
          this.getOrder(contract, orderItem => {
            this.getPay(orderItem); // 获取财务流水
          });
          this.getRepeatContract(); //重复合同
          this.getContacts(contract); //获取客户
          this.getSettlDetails(); //获取结算明细
          this.getServiceAppointmentData(contract.serviceAppointmentId);
          this.getExtForm(); //增减项协议、退款说明接口
          this.isCallFn(); //判断是否从列表点击打电话，自动调打电话接口和弹出弹窗
        });
      });
    });
    // this.osg.ajax(
    //   'biz/extField/query.do',
    //   {
    //     colName: 'contract',
    //     _all: '1',
    //     'is:state|integer#and': 1,
    //     'nin:preset|array-integer#and': 1,
    //     sortField: 'order',
    //     sortOrder: 'asc'
    //   },
    //   res => {
    //     this.extFields = res.data;
    //     this.options = this.options || [];
    //     for (var item of res.data) {
    //       if (item.valueOption)
    //         this.options['codecfg_' + item.valueOption] = {
    //           codeId: item.valueOption
    //         };
    //       //级联
    //       if (item.type == 'cascade')
    //         this.options['cascadeCode_' + item.valueOption] = {
    //           codeId: item.valueOption
    //         };
    //       //解析frontEndConfig字段配置
    //       if (item.frontEndConfig && this.osg.isJson(item.frontEndConfig)) {
    //         item.frontEndConfig = JSON.parse(item.frontEndConfig);
    //       }
    //     }
    //     this.osg.codeoption(() => {
    //       this.getData(contract => {
    //         this.getOrder(contract, orderItem => {
    //           this.getPay(orderItem); //获取财务流水
    //         });
    //         this.getRepeatContract(); //重复合同
    //         this.getContacts(contract); //获取客户
    //         this.isCallFn(); //判断是否从列表点击打电话，自动调打电话接口和弹出弹窗
    //       });
    //     });
    //   },
    //   { noload: true }
    // );
  },
  methods: {
    getData(callback) {
      this.osg.ajax(`basic/contract/queryById/${this.id}.do`, {}, res => {
        this.contract = res.entity;
        this.contract.exts = this.contract.exts ? this.contract.exts : {};
        let list = this.contract.qiniuUrls.reverse();
        this.pdfList = list.slice(0, 1);
        //解析合同存储的合同附件列表
        this.attachmentData.attachmentList = this.osg.isJson(res.entity.exts.attachmentList)
          ? JSON.parse(res.entity.exts.attachmentList)
          : [];
        // //解析合同存储变更条款列表
        // this.attachmentData.changeClauseList = this.osg.isJson(res.entity.exts.attachmentList)
        //   ? JSON.parse(res.entity.exts.attachmentList)
        //   : [];
        if (callback) callback(this.contract);
      });
    },
    // 获取增减项协议、退款说明接口
    getExtForm() {
      this.osg.ajax(
        'basic/contract/querySupplementTreaty.do', //增减项协议接口
        { contractId: this.contract._id },
        res => {
          this.attachmentData.addAttachmentList = [];
          this.attachmentData.deductionAttachmentList = [];
          if (Array.isArray(res.data)) {
            // 1减项、0增项
            res.data.forEach(item => {
              if (item.type == '1') {
                this.attachmentData.deductionAttachmentList.push(item);
              } else {
                this.attachmentData.addAttachmentList.push(item);
              }
            });
          }
        }
      );
      //退款说明接口
      this.osg.ajax(
        'basic/contract/queryContractRefund.do',
        { contractId: this.contract._id },
        res => {
          if (Array.isArray(res.data)) {
            this.attachmentData.refundDataList = res.data;
            console.log(this.attachmentData.refundDataList);
          }
        }
      );
      // 补充协议接口
      this.osg.ajax(
        'basic/contract/querySingleSupplementTreaty.do',
        { contractId: this.contract._id },
        res => {
          this.attachmentData.singleSupplementTreatyList = [];
          if (Array.isArray(res.data)) {
            // 1减项、0增项
            res.data.forEach(item => {
              this.attachmentData.singleSupplementTreatyList.push(item); //补充协议
            });
          }
        }
      );
    },
    doSave() {
      if (this.osg.validate()) {
        if (this.osg.isRepeatClick('doSave', 5000)) {
          return;
        }
        this.osg.ajax(
          `/basic/contract/modify/${this.contract._id}.do`,
          { contactsName: this.contract.contactsName, contactsPhone: this.contract.contactsPhone },
          () => {
            this.getData(() => {
              this.osg.toast('保存成功！');
              this.messageDialog = false;
            });
          }
        );

        // this.$util.saveExtField(this.contactsExtFields, this.contract);
        // this.osg.ajax('basic/contract/upsert.do', { data: JSON.stringify(this.contract) }, res => {
        //   this.getData(() => {
        //     this.osg.toast('保存成功！');
        //     this.messageDialog = false;
        //   });
        // });
      }
    },
    getFields(callback) {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'contract',
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order,createTime',
          sortOrder: 'asc'
        },
        res => {
          //NPS列单独展示
          this.extFields = res.data.filter(item => {
            if (item.showList && item.showList.includes('2')) {
              //解析frontEndConfig字段配置
              if (item.frontEndConfig && this.osg.isJson(item.frontEndConfig)) {
                item.frontEndConfig = JSON.parse(item.frontEndConfig);
              }
              if (this.handleType != 'NPS') {
                if (item.frontEndConfig && item.frontEndConfig.nps) {
                  return false;
                }
              }
              if (this.handleType == 'NPS') {
                if (item.frontEndConfig && item.frontEndConfig.hideNPS) {
                  return false;
                }
              }
              return true;
            } else {
              return false;
            }
          });
          this.options = this.options || [];
          //扩展字段选项关联字典表的查询出选项数据
          for (var item of res.data) {
            //解析frontEndConfig字段配置
            if (item.frontEndConfig && this.osg.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }

          if (callback) callback();
        },
        {
          noload: true
        }
      );
    },
    //获取订单
    getOrder(contract, callback) {
      this.params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'is:_id|string#and': contract.orderId
      };
      this.osg.ajax('basic/order/query.do', this.params, res => {
        if (res && res.data && contract.orderId) {
          if (callback) callback(res.data[0]);
        }
      });
    },
    //重复已完工合同
    getRepeatContract() {
      if (this.contract.contactsPhone) {
        this.params = {
          'exists:endDate|boolean#and': true,
          'is:contactsPhone|string#and': this.contract.contactsPhone,
          'in:state|array-integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        this.osg.ajax('basic/contract/query.do', this.params, res => {
          if (res.data) {
            this.repeatContract = res.data;
          }
        });
      } else {
        this.repeatContract = [];
      }
    },
    //支付记录（财务流水）
    getPay(orderItem) {
      if (!orderItem._id || !orderItem.contractNum) return; // 当合同取消或归档时会删除订单上的合同编号，当订单上没有合同编号时此处不查询财务流程。
      this.params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        orderId: orderItem._id,
        contractNum: orderItem.contractNum,
        'ne:state|integer#and': '-1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('i/pay/queryThroughOrderId.do', this.params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //获取客户
    getContacts(contract) {
      // return;
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'contacts',
          _all: '1',
          'is:state|integer#and': 1,
          'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.contactsExtFields = res.data;
          this.options = this.options || [];
          for (var item of res.data) {
            if (item.valueOption)
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          this.osg.codeoption(() => {
            this.osg.ajax('basic/contacts/queryById.do', { id: contract.contactsId }, res => {
              this.formData = res;
            });
          });
        },
        { noload: true }
      );
    },
    //获取结算明细
    getSettlDetails() {
      let contractId = this.contract._id;
      let params = {
        // '_all':'1',
        'all:sourceTypeIdList|array#and': contractId,
        // 'all:sourceTypeIdList|array#and': '1163110593477626016',
        'in:state|array-integer#and': '0,1'
        // 'regex:sourceTypeType|array#and': 1,
        // sortField: 'createTime',
        // sortOrder: 'desc'
      };
      this.osg.ajax('biz/settle/query.do', params, res => {
        if (res.data[0]) {
          if (!res.data[0]._id) return;
          this.osg.ajax(`biz/settle/queryById/${res.data[0]._id}.do`, params, res => {
            this.settleDetailData.itemList = res.entity.itemList.filter(item => {
              if (item.data) {
                console.log(item.data._id, contractId);
                return item.data._id == contractId;
              }
            });
            console.log(this.settleDetailData.itemList);
          });
        }
      });
    },
    //获取关联工单
    getServiceAppointmentData(sid) {
      if (sid) {
        var params = {
          page: 1,
          rows: 1,
          sortField: 'createTime',
          sortOrder: 'desc',
          'is:_id|string#and': sid
        };
        this.osg.ajax(
          'basic/serviceAppointment/query.do',
          params,
          res => {
            res.data.map(item => {
              item.label = item.name;
              item.value = item._id;
            });
            this.serviceAppointment.relatedData = res.data;
            this.$forceUpdate();
          },
          { noload: true }
        );
      }
    },
    edit() {
      // this.formData
      if (this.contract.exts && this.contract.exts.workType == '3') {
        this.messageDialog = true;
      } else {
        this.osg.toast('只能编辑线下的合同！', 'warning');
      }
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue) == '未知'
        ? cellValue
        : this.osg.codelabel('fields', cellValue);
    },
    pageSizeChange(pageSize) {
      if (this.SR.show) {
        this.SR.fpi.rows = pageSize;
        this.getSR();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.SR.show) {
        this.SR.fpi.page = currentPage;
        this.getSR();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    /**
     * 切换tab页
     */
    tabClick(tab) {
      switch (tab.name) {
        case 'history':
          this.getHistory();
          break;
        case 'record':
          this.getRecord();
          break;
        case 'TabNPS':
          this.getExtFieldsNPS(() => {
            this.osg.codeoption(() => {
              this.getTabNPS();
            });
          });
          break;
        case 'ticket':
          this.getExtFieldsNPS(() => {
            this.osg.codeoption(() => {
              this.getForfeitData(forfeitData => {
                this.getQuestionNPS(forfeitData);
                this.getForfeitLog(forfeitData);
              });
            });
          });
          break;
        case 'NPSlog':
          this.getTabNPS();
          break;
        // case 'callRecords':
        //   this.getCallRecords();
        //   break;
        // case 'history':
        //   this.getHistory();
        //   break;
        default:
          return;
      }
    },
    //获取跟进记录
    getRecord() {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        bizType: 'Contract',
        bizId: this.id
      };
      this.osg.ajax(
        'followingUpNote/query.do',
        params,
        res => {
          if (res.data) {
            this.record.fpi = res;
          }
        },
        {
          noload: true
        }
      );
    },
    //NPS表单
    getTabNPS() {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        bizType: 'Contract',
        bizId: this.id
      };
      this.osg.ajax(
        'basic/nps/query.do',
        params,
        res => {
          this.getParameterData('questionBank', () => {
            let questionBankCopy = this.$util.deepCopy(this.options['questionBank']);
            if (res.data.length) {
              let NPSData = res.data[0];
              //给选项设置默认值
              NPSData.questionAndReply = NPSData.questionAndReply.map(item => {
                if (!item.whether) item.whether = '0';
                return item;
              });
              this.TabNPS.data = NPSData;
            } else {
              this.TabNPS.data = { questionAndReply: [] };
              //随机给出nps问题
              for (let i = 3; i > 0; i--) {
                let randomNum = Math.floor(Math.random() * questionBankCopy.length);
                // this.options['questionBank_random'].push(questionBankCopy[randomNum]);
                this.TabNPS.data.questionAndReply.push({
                  question: questionBankCopy[randomNum].value,
                  reply: this.findParameterKey(questionBankCopy[randomNum], 'reply') || '0',
                  whether: ''
                });
                questionBankCopy.splice(randomNum, 1);
              }
              console.log('questionBankCopy', this.TabNPS.data, questionBankCopy);
            }
          });
        },
        {
          noload: true
        }
      );
    },
    //获取问题NPS-罚款专用
    getQuestionNPS(data) {
      if (data && data.typeId) {
        var params = {
          id: data.typeId
        };
        this.osg.ajax(
          'basic/nps/findById.do',
          params,
          res => {
            if (res.entity) {
              this.ticket.fpi.data = res.entity;
            }
          },
          {
            noload: true
          }
        );
      }
    },
    //罚款列表
    getForfeitData(callback) {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|integer#and': 1,
        sourceType: 'Contract',
        'is:sourceTypeId|string#or': this.id,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/forfeit/query.do', params, res => {
        if (res.data && res.data.length) {
          this.ticket.forfeit = res;
          if (callback) callback(res.data[0]);
        }
      });
    },
    //查看罚款日志
    getForfeitLog(row) {
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: row._id,
          smodule: 'forfeit',
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.ticket.log.fpi = res;
          if (res.data && res.data.length) this.ticket.isforfeitLog = true;
        },
        { noload: true }
      );
    },
    //合同跟进日志
    getLog() {
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          // smodule: 'contract',
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.tenantLog.fpi = res;
        },
        { noload: true }
      );
    },
    //查看罚款日志
    viewForfeit() {
      this.ticket.openForfeitogDetail = true;
    },
    //NPS表单所需字段
    getExtFieldsNPS(callback) {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'netPromoterScore',
          _all: '1',
          'is:state|integer#and': 1,
          //   'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          //NPS表单在页面禁用字段
          this.extFieldsNPS = res.data;
          this.options = this.options || [];
          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          let disableData = this.$util.deepCopy(res.data);
          this.extFieldsDisableNPS = this.$util.deepCopy(
            disableData.map(nItem => {
              nItem.operationType = 3;
              return nItem;
            })
          );
          if (callback) callback();
        },
        { noload: true }
      );
    },
    /**
     * 操作记录
     */
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res) {
            if (res.data.length > 0) {
              // 不需要展示变更的字段名
              res.data = res.data.filter(item => {
                item.modifyList = item.modifyList.filter(obj => {
                  return (
                    this.fieldsObj[obj.field] &&
                    this.fieldsObj[obj.field].showList.indexOf('6') != -1
                  );
                });
                return item.modifyList.length > 0;
              });
              this.historyFpi = res;
            }
          }
        },
        { noload: true }
      );
    },
    //生成uuid（18位），随机数（5位）+时间戳（13位）
    randomUUid() {
      let num = '';
      for (var i = 0; i < 5; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return num + new Date().valueOf();
    },
    //保存跟进记录ajax
    saveRecordAjax(data, callback) {
      //跟进记录需要前端生成_id
      data._id = data._id ? data._id : this.randomUUid();
      let params = {
        bizType: 'Contract',
        bizId: this.contract._id
        // callId: this.callId
      };
      params = Object.assign(params, data);
      this.osg.ajax('followingUpNote/upsert.do', params, () => {
        this.getRecord();
        if (callback) callback();
      });
    },
    //创建跟进记录
    saveRecord() {
      if (this.osg.validate('recordFormData')) {
        if (this.osg.isRepeatClick('saveNPS', 5000)) {
          return;
        }
        this.saveRecordAjax(this.record.recordFormData, () => {
          this.getTabNPS();
          this.TabNPS.openRecord = false;
          this.osg.toast('保存成功！');
        });
      }
    },
    //保存NPS对象
    saveNPS() {
      if (this.TabNPS.data.questionAndReply.some(item => !item.question || !item.whether)) {
        this.osg.toast('NPS问题或回答不能为空！', 'warning');
        return;
      }
      if (this.osg.validate('recordFormData', this) && this.osg.validate('formData.form', this)) {
        if (this.osg.isRepeatClick('saveNPS', 5000)) {
          return;
        }
        let params = this.TabNPS.data;
        this.saveRecordAjax(this.record.recordFormData, () => {
          params.bizId = this.contract._id;
          params.bizType = 'Contract';
          params.bizCode = this.contract.contractdocNum;
          params.exts = params.exts || {};
          // debugger;
          //NPS对象exts里冗余存储伙伴字段(id，省市区，服务商名称)
          if (this.contract.partner) {
            params.partnerId = this.contract.partner._id;
            params.partnerName = this.contract.partner.name;
            params.partnerProvince = this.contract.exts.province;

            params.exts.partnerProvince = this.contract.exts.province;
            params.exts.partnerCity = this.contract.exts.city;
            params.exts.partnerDistrict = this.contract.exts.district;
          }
          //对NPS问题进行处理，将选择扣款的问题扣款
          // params.questionAndReply = params.questionAndReply.map(qItem => {
          //   if (qItem.whether > 0) {
          //     qItem.reply = String(qItem.question).slice(String(qItem.question).indexOf(',') + 1);
          //   } else {
          //     qItem.reply = '0';
          //   }
          //   return qItem;
          // });
          params.questionAndReply = params.questionAndReply.map(qItem => {
            if (!(qItem.whether > 0)) {
              qItem.reply = '0';
            }
            return qItem;
          });
          this.osg.ajax('basic/nps/upsert.do', params, () => {
            this.getTabNPS();
            this.TabNPS.openRecord = false;
            this.osg.toast('保存成功！');
          });
        });
      }
    },
    //选择罚款问题change事件
    selectionQuestion(opValue, row) {
      row.reply =
        this.findParameterKey(
          this.options['questionBank'].find(item => item.value == opValue),
          'reply'
        ) || '0';
    },
    //通用修改exts字段接口
    markEmbodiment() {
    if (this.osg.validate('attachmentForm')) {
      if (Array.isArray(this.attachmentData.fileList)) {
        let fileList = this.attachmentData.fileList.map(item => {
          if (item.response) {
            return {
              url:
                window.$this.osg.downloadUrl +
                item.response.key.replace(window.$this.osg.downloadUrl, ''),
              name: item.name || item.response.key,
              response: item.response
            };
          } else {
            return {
              url:
                window.$this.osg.downloadUrl + item.url.replace(window.$this.osg.downloadUrl, ''),
              name: item.name || item.response.key,
              response: item.response
            };
          }
        });

        if (this.attachmentData.fileListName != 'attachmentList') {
          this.attachmentData[this.attachmentData.name][
            this.attachmentData.itemIndex
          ].imagesName = this.attachmentData.imagesName;

          this.attachmentData[this.attachmentData.name][this.attachmentData.itemIndex][
            this.attachmentData.fileListName
          ] = fileList;
        } else {
          // console.log(this.attachmentData);
          // debugger;
          this.attachmentData[this.attachmentData.name] = fileList;
        }
      }
      //  else {
      //   this.attachmentData[this.attachmentData.name][this.attachmentData.fileListName] = [];
      // }

      // console.log({
      //   id: this.id,
      //   name: this.attachmentData.name,
      //   value: this.attachmentData[this.attachmentData.name],
      //   className: 'com.fsgo.entity.basic.Contract'
      // });
      // return;
      let row = this.attachmentData[this.attachmentData.name][this.attachmentData.itemIndex];
      if (
        this.attachmentData.name == 'addAttachmentList' ||
        this.attachmentData.name == 'deductionAttachmentList'
      ) {
        // 通用修改exts字段接口
        this.osg.ajax(
          'basic/contract/upsertSupplementTreaty.do',
          {
            contractSupplementTreaty: JSON.stringify(row)
          },
          () => {
            this.attachmentData.openDetail = false;
            this.getExtForm(); //增减项协议、退款说明接口
            this.osg.toast('操作成功！');
          }
        );
      } else if (this.attachmentData.name == 'attachmentList') {
        // 通用修改exts字段接口
        this.osg.ajax(
          'i/markEmbodiment/all.do',
          {
            data: JSON.stringify([
              {
                id: this.id,
                name: 'attachmentList',
                value: this.attachmentData.attachmentList,
                className: 'com.fsgo.entity.basic.Contract'
              }
            ])
          },
          () => {
            this.attachmentData.openDetail = false;
            this.getData();
            this.osg.toast('操作成功！');
          }
        );
      } else if (this.attachmentData.name == 'singleSupplementTreatyList') {
        // 补充协议接口
        this.osg.ajax(
          'basic/contract/upsertSingleSupplementTreaty.do',
          {
            singleSupplementTreaty: JSON.stringify(row)
          },
          () => {
            this.attachmentData.openDetail = false;
            this.getData();
            this.osg.toast('操作成功！');
          }
        );
      } else {
        // 退款说明接口
        this.osg.ajax(
          'basic/contract/upsertContractRefundPdf.do',
          {
            contractRefundPdf: JSON.stringify(row)
          },
          () => {
            this.attachmentData.openDetail = false;
            this.getExtForm(); //增减项协议、退款说明接口
            this.osg.toast('操作成功！');
          }
        );
      }
    }
    },
    //打开上传附件弹窗
    openUploadAttachment(fileListName, name, itemIndex, imagesName) {
      this.attachmentData.fileListName = fileListName; //上传列表名称
      this.attachmentData.name = name; //对象名称
      this.attachmentData.imagesName = imagesName || ''; //上传图片名称
      this.attachmentData.itemIndex = itemIndex; //列的索引
      if (fileListName == 'images') {
        this.attachmentData.fileList = this.attachmentData[name][itemIndex][fileListName];
      } else {
        this.attachmentData.fileList = this.attachmentData[fileListName];
      }
      this.attachmentData.openDetail = true; //打开弹窗
      // console.log(this.attachmentData);
    },
    //查找参数表里的key
    findParameterKey(row, key) {
      let replyData = row.parameterList.find(paramItem => paramItem.key == key);
      return replyData && replyData.value;
    },
    //创建NPS按钮
    doNewNPS() {
      this.TabNPS.openRecord = true;
      if (this.TabNPS.data.mode) delete this.TabNPS.data.mode; //清空回访状态
    },
    //给字典表扩展属性
    getParameterData(sourceTypeType, callBack) {
      if (!sourceTypeType) return;
      this.osg.ajax(
        'code/query.do',
        {
          type: sourceTypeType,
          'nin:state|integer#and': [-1],
          _all: '1'
        },
        codeRes => {
          let params = {
            _all: '1',
            'in:state|array-integer#and': '0,1',
            'in:sourceType|integer#and': 2, //参数来源
            'is:sourceTypeType|string#and': sourceTypeType,
            sortField: 'key',
            sortOrder: 'desc'
          };
          this.osg.ajax('parameter/query.do', params, res => {
            this.options[sourceTypeType] = codeRes.data.map(item => {
              item.parameterList = [];
              res.data.forEach(pItem => {
                if (item._id == pItem.sourceTypeId) item.parameterList.push(pItem);
              });
              item.label = item.name;
              return item;
            });
            if (callBack) callBack();
          });
        }
      );
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue) || cellValue;
      } else {
        return cellValue;
      }
    },
    formatterPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    //反显字典表
    formatterCodelabel(cellValue, valueOption, type) {
      if (type == 'cascade' && cellValue && cellValue.indexOf(',') != -1) {
        let value = cellValue.split(',');
        if (Array.isArray(value)) {
          let result = '';
          for (let item of value) {
            result += this.cascadeCodelabel(valueOption, item) + '-';
          }
          return result.substring(0, result.length - 1); //删除最后字符
        }
      } else if (type == 'cascade' && valueOption && Array.isArray(cellValue)) {
        let result = '';
        for (let item of cellValue) {
          result += this.cascadeCodelabel(valueOption, item) + '-';
        }
        return result.substring(0, result.length - 1); //删除最后字符
      } else if (cellValue && valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    cascadeCodelabel: function(codeType, codeValue) {
      var opts = this.options[codeType];
      opts = this.cascadeFlat(opts);
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].name;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    },
    cascadeFlat(source) {
      if (Array.isArray(source)) {
        let flatArr = [];
        let fn = function(source) {
          source.forEach(el => {
            flatArr.push(el);
            if (el.children && el.children.length > 0) fn(el.children);
          });
        };
        fn(source);
        return flatArr;
      } else {
        return source;
      }
    },
    formatPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    formatUnlockPay(row, column, cellValue) {
      if (Array.isArray(cellValue)) {
        return cellValue.indexOf(Number(this.formData.type)) != -1 ? '已解付' : '未解付';
      } else {
        return this.osg.codelabel('unlockPay', cellValue);
      }
    },
    //反显开关的值
    formatterSwitch(cellValue, frontEndConfig) {
      frontEndConfig = frontEndConfig
        ? frontEndConfig
        : {
            activeText: '是',
            activeValue: 1,
            inactiveText: '否',
            inactiveValue: 0
          };
      if (cellValue == frontEndConfig.activeValue) {
        return frontEndConfig.activeText;
      } else if (cellValue == frontEndConfig.inactiveValue) {
        return frontEndConfig.inactiveText;
      } else {
        return cellValue;
      }
    },
    //反显委托人
    formatUserId(row, column, cellValue) {
      for (let item of this.contactList) {
        if (item._id == cellValue) return item.name;
      }
    },
    //计算差额
    formatDifference(row) {
      let difference = row.totalAmount - row.paidAmount;
      return Math.abs(difference) || 0;
    },
    formatterAuditstate(row, column, cellValue) {
      return this.osg.codelabel('auditstate', cellValue);
    },
    formatterPaymentRecordType(row) {
      if (!row) return '未知';
      return row.price > 0 ? '支付' : '退款';
    },
    formatterPayType(row, column, cellValue) {
      return this.osg.codelabel('payType', cellValue);
    },
    formatterOrderType(row, column, cellValue) {
      return this.osg.codelabel('orderPayType', cellValue);
    },
    formatterTradeIn(row, column, cellValue) {
      return this.osg.codelabel('tradeIn', cellValue);
    },
    formatDeductType(row, column, cellValue) {
      return this.osg.codelabel('deductType', cellValue);
    },
    formatCallResult(val) {
      if (!val) return '';
      return this.osg.codelabel('callResult', val);
    },
    formatMiddleCallResult(val) {
      return this.osg.codelabel('middleCallResult', val);
    },
    getSummaryTotal(param) {
      const { columns, data } = param;
      const sums = [];
      let arr = ['amountOrigin', 'settleItemAmount', 'adjustAmount', 'amount']; //需要合计的字段
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (arr.indexOf(column.property) !== -1) {
          let total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.settleToMoney(total); //保留两位小数点
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //复制filter的代码-用于保留两位小数
    settleToMoney(val) {
      if (!val) {
        return 0;
      } else {
        val = Number(val).toFixed(2);
        let reg = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
        return val.toString().replace(reg, '$1,');
      }
    },
    //判断是否从列表点击打电话，自动调打电话接口和弹出弹窗
    isCallFn() {
      this.getRecord(); //跟进记录列表

      //从列表点击打电话，自动调打电话接口和弹出弹窗
      const isCall = this.$route.params.isCall;
      if (isCall) {
        // this.openRecordFun();
        this.osg.sobot.selfCallOut(
          {
            callNum: this.contract.contactsPhone,
            bizType: 'Contract',
            bizId: this.contract._id
          },
          this.callOutBack
        );
        this.$route.params.isCall = null; //消除来电标识
      }
    },
    //拨打电话回调，将callid存储，如果要记录跟进记录，存储到跟进记录对象上
    callOutBack(data) {
      if (data) {
        this.contract.phone = this.contract.contactsPhone; //电话表单依赖这个phone字段
        this.callId = data.callID;
        this.activeTab = 'record';
        // this.record.openRecord = true;

        this.$emit('objectDataFn', {
          exhaleOpen: true, //打开呼出
          bizId: this.contract._id,
          bizType: 'Contract',
          callId: data.callID,
          caller: this.contract.phone,
          formData: this.contract,
          extFields: this.extFields,
          //   SAextFields: this.SAextFields,
          options: this.options,
          handleType: this.handleType //操作类型 NPS
        });
      }
    },
    //查看通话记录
    viewCallRecord(callId) {
      this.osg.ajax(
        'basic/sobot/queryByCallId.do',
        {
          callId
        },
        res => {
          if (res.data) {
            this.record.callData = res.data;
            this.record.openCallRecord = true;
          }
        },
        { noload: true }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
</style>
<style>
#contract .contractLink .el-link--inner {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#contract .el-card {
  font-size: 14px;
}
#contract .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 20px 0;
}
.c-upload-maxLimit .el-icon-close {
  display: none !important;
}
#contract .el-icon-close-tip {
  display: none !important;
}
</style>
